import GET_BEST_OF_RING_PAGES from '@amzn/ring-neighbors-contentful-gql-schema/operations/best-of-ring/getBestOfRingPages.graphql';
import { useContentfulQuery } from 'src/hooks/useContentfulQuery';
import type { GetBestOfRingPagesQuery } from '@amzn/ring-neighbors-contentful-gql-schema';

export const useBestOfRingPage = () => {
  const { data, error, ...rest } = useContentfulQuery<GetBestOfRingPagesQuery>(
    GET_BEST_OF_RING_PAGES,
  );

  if (error) throw new Error('Contentful not reachable');

  return {
    ...rest,
    data: data?.bestOfRingPageCollection?.items?.[0],
  };
};
